import Phaser from 'phaser';
import { createRng } from '@rabbit2/shared/sim';
import { showVila } from '../ui/overlay.ts';
import { totalLuar } from '../save.ts';

/** Vila (hub): cena noturna "Moonlit Storybook" com casinhas Sutarifu e coelhos + overlay de Luar. */
export class VilaScene extends Phaser.Scene {
  #total = 0;

  constructor() {
    super('vila');
  }

  init(data: { total?: number }): void {
    this.#total = data.total ?? totalLuar();
  }

  /** casinha Sutarifu com janela acesa. */
  #casa(x: number, baseY: number, cor: number, rng: () => number): void {
    const g = this.add.graphics().setDepth(2);
    const w = 70 + rng() * 26;
    const h = 54 + rng() * 22;
    const y = baseY - h;
    g.fillStyle(0x2a2350, 1).fillRoundedRect(x, y, w, h, 6); // parede
    g.fillStyle(cor, 1).fillTriangle(x - 6, y + 2, x + w + 6, y + 2, x + w / 2, y - 26); // telhado
    g.lineStyle(2, 0x161033, 1).strokeTriangle(x - 6, y + 2, x + w + 6, y + 2, x + w / 2, y - 26);
    g.fillStyle(0xffe08a, 0.95).fillRoundedRect(x + w / 2 - 9, y + h / 2 - 9, 18, 18, 3); // janela acesa
    g.fillStyle(0xffe08a, 0.18).fillCircle(x + w / 2, y + h / 2, 22); // brilho
  }

  create(): void {
    this.cameras.main.setBackgroundColor('#161233');
    const rng = createRng(7, 3);
    const r = (): number => rng.next01();

    // céu estrelado
    const sky = this.add.graphics().setDepth(0);
    for (let i = 0; i < 130; i++) {
      const grande = r() < 0.12;
      sky.fillStyle(grande ? 0xfff176 : 0xfff3c4, 0.25 + r() * 0.6);
      sky.fillCircle(r() * 960, r() * 380, grande ? 2.2 : 1);
    }
    if (this.textures.exists('moon')) this.add.image(800, 110, 'moon').setDepth(1).setDisplaySize(170, 170).setAlpha(0.95);

    // colinas + chão de gramado
    const ground = this.add.graphics().setDepth(1);
    ground.fillStyle(0x241f47, 1).fillEllipse(220, 470, 640, 220);
    ground.fillStyle(0x2a2350, 1).fillEllipse(760, 480, 560, 200);
    ground.fillStyle(0x1e1a3a, 1).fillRect(0, 470, 960, 90);

    // casinhas Sutarifu (5 trilhas → 5 cores)
    const cores = [0xff8a3d, 0xffd166, 0xbfd7ea, 0x7c5cff, 0xff5d8f];
    const xs = [70, 210, 610, 760, 880];
    xs.forEach((x, i) => this.#casa(x, 476, cores[i] ?? 0xff8a3d, r));

    // coelhos passeando
    if (this.textures.exists('pip')) {
      this.add.image(330, 452, 'pip').setDepth(3).setDisplaySize(48, 54);
      this.add.image(520, 456, 'pip').setDepth(3).setDisplaySize(40, 45).setFlipX(true);
    }

    window.__rabbitTest = {
      ...(window.__rabbitTest ?? {}),
      scene: () => 'vila',
      fps: () => this.game.loop.actualFps,
      seed: () => 0,
      rngSample: window.__rabbitTest?.rngSample ?? (() => []),
    };
    this.game.canvas.setAttribute('data-ready', 'true');

    showVila(this.#total, () => {
      const seed = (this.#total * 2654435761 + this.time.now * 1000) >>> 0 || 1;
      this.scene.start('run', { seed, speed: 1 });
    });
  }
}
